<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kMfh2a/images/9781613732670_cover.jpg?1740245403338" alt="This image is the cover for the book Dead Man's Shoes, Tales of the PanCosmos"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dead Man's Shoes, Tales of the PanCosmos
      </h1>
      <p class="bookDescription body article font2">
        <p>Everyone knew there'd been a murder, everyone knew who the murderer was, and when this murderer committed suicide by jumping overboard from the cargo boat Saragossa, they thought "Good riddance." Everyone, that is, except Carolus Deene.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leo Bruce
      </h2>
      
      <p class="authorDescription body article">Leo Bruce was the pen name of Rupert Croft-Cooke, who wrote more than twenty highly praised mysteries featuring Carolus Deene. He also wrote eight mysteries featuring Sergeant William Beef, a cockney police detective who invariably knows who done it.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chicago Review Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d828cf1